import t from '@jetshop/intl';
import React from 'react';
import { styled } from 'linaria/react';
import { theme } from '../../../Theme';

const ButtonRow = styled('div')`
  position: relative;
  width: 100%;
  max-width: 1000px;
  padding: 0 20px;
  margin: 20px auto;
  .inner {
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    grid-gap: 30px;
    &:after {
      content: '';
      height: 2px;
      background: #f7f7f7;
      position: absolute;
      left: 0;
      right: 0;
      top: 100%;
    }
  }
`;
const Toggle = styled('div')`
  position: relative;
  font-size: 14px;
  font-weight: 700;
  color: ${theme.colors.darkgrey};
  height: 50px;
  line-height: 50px;
  text-transform: uppercase;
  cursor: pointer;

  &:after {
    content: '';
    background: ${theme.colors.darkgrey};
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    transition: all, 0.1s;
    width: 0;
    height: 4px;
  }

  &:hover {
    &:after {
      width: 100%;
    }
  }

  &.active {
    &:after {
      content: '';
      width: 100%;
      background: ${theme.colors.black};
    }
  }
`;
const TabContent = styled('div')`
  width: 100%;
  max-width: 1000px;
  padding: 0 20px 20px 20px;
  margin: auto;
  margin-bottom: 1.5rem;
`;
export const TabInner = styled('div')`
  font-size: 13px;
  line-height: 1.6;
  margin-bottom: 1rem;
  p {
    font-size: 15px;
    line-height: 1.6;
    margin-bottom: 1rem;
  }
  h2,
  h3,
  h4,
  h5 {
    margin: 0;
  }

  h2 {
    font-size: 20px;
  }
  h3 {
    font-size: 18px;
  }

  ul {
    padding-left: 1rem;
    list-style-type: disc;
    margin-bottom: 1rem;
    li {
      font-size: 13px;
      line-height: 1.9;
    }
  }

  table {
    border: 0;
    min-width: 50%;
    width: auto !important;
    th {
      border: 0;
    }
    tr {
      background: #f7f7f7;
      &:nth-child(even) {
        background: white;
      }

      td {
        padding: 7px 10px;
        text-align: right;
        font-size: 13px;
        line-height: 1.6;
        border: 0;
        &:nth-child(1) {
          text-align: left;
        }
      }
    }
  }
  .even,
  .odd {
    display: grid;
    grid-template-columns: 270px 1fr;
    grid-template-rows: 30px;
    align-items: center;
    height: 30px;
    padding: 0 11px;
    & > p {
      margin: 0;
    }
    .spec-title {
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 0.1rem;
      text-transform: uppercase;
    }
    .spec-value {
      font-size: 14px;
      font-weight: 300;
    }
  }
  .even {
    background: ${theme.colors.lightgrey};
  }
`;

const ProductTabs = ({ product, remoteOpenIndex, setRemoteOpenIndex }) => {
  const customFields = product?.customFields;
  const hasDescription = !!product?.description;
  const hasSpecification = !product?.customFields.length < 1;
  const EAN = product?.barcode;
  const showEAN = EAN && EAN.length > 0;

  const handleClick = index => {
    setRemoteOpenIndex(index);
  };

  //const { lipscoreRef } = useLipscoreLoader('743ec6465801a13b5374f917');

  return (
    <>
      <ButtonRow>
        <div className="inner">
          {hasDescription && (
            <Toggle
              className={remoteOpenIndex === 0 && 'active'}
              onClick={() => handleClick(0)}
            >
              {t('Product description')}
            </Toggle>
          )}
          {hasSpecification && (
            <Toggle
              className={remoteOpenIndex === 1 && 'active'}
              onClick={() => handleClick(1)}
            >
              {t('Specifications')}
            </Toggle>
          )}
        </div>
      </ButtonRow>

      <TabContent>
        <TabInner style={{ display: remoteOpenIndex === 0 ? 'block' : 'none' }}>
          <div
            dangerouslySetInnerHTML={{
              __html: product?.description
            }}
          />
          {showEAN ? (
            EAN && <p>EAN: {EAN}</p>
          ) : (
            <p>
              {t('Article number')}: {product?.articleNumber}
            </p>
          )}
        </TabInner>
        {hasSpecification && (
          <TabInner
            style={{ display: remoteOpenIndex === 1 ? 'block' : 'none' }}
          >
            {customFields.length < 1 ? (
              <div>
                <p className="even">Specifikationer saknas</p>
              </div>
            ) : (
              customFields?.map((field, index) => {
                return (
                  <div className={index % 2 === 0 ? 'even' : 'odd'}>
                    <p className="spec-title">{field?.title}</p>
                    <p className="spec-value">{field?.stringValue}</p>
                  </div>
                );
              })
            )}
          </TabInner>
        )}
        {/* <TabInner style={{ display: remoteOpenIndex === 4 ? 'block' : 'none' }}>
          <LipscoreReviewList product={product} lipscoreRef={lipscoreRef} />
        </TabInner> */}
      </TabContent>
    </>
  );
};

export default ProductTabs;
